import { useState } from 'react';
import PageHeader from '../../components/PageHeader';
import UsersSection from './maintenance/UsersSection';
import ProductsSection from './maintenance/ProductsSection';
import AuditLogSection from './maintenance/AuditLogSection';
import styles from './MaintenancePage.module.css';

const NAV_CARDS = [
  {
    key: 'users',
    label: 'Users',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
      </svg>
    ),
  },
  {
    key: 'products',
    label: 'Products',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/>
      </svg>
    ),
  },
  {
    key: 'auditlog',
    label: 'Audit Log',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
];

const SECTION_TITLES = {
  users:    { label: 'Users',     desc: 'Manage user accounts and roles' },
  products: { label: 'Products',  desc: 'Full product catalog control' },
  auditlog: { label: 'Audit Log', desc: 'System activity log — read only' },
};

export default function MaintenancePage() {
  const [activeSection, setActiveSection] = useState(null);

  function handleCardClick(key) {
    setActiveSection(prev => prev === key ? null : key);
  }

  return (
    <div className={styles.page}>
      <PageHeader title="Maintenance" description="System administration" />

      <div className={styles.cardRow}>
        {NAV_CARDS.map(card => (
          <button
            key={card.key}
            className={`${styles.navCard} ${activeSection === card.key ? styles.navCardActive : ''}`}
            onClick={() => handleCardClick(card.key)}
            aria-pressed={activeSection === card.key}
          >
            <span className={styles.cardIcon}>{card.icon}</span>
            <span className={styles.cardLabel}>{card.label}</span>
          </button>
        ))}
      </div>

      {activeSection && (
        <div className={styles.sectionWrap}>
          <div className={styles.sectionHeader}>
            <div>
              <h2 className={styles.sectionTitle}>{SECTION_TITLES[activeSection].label}</h2>
              <p className={styles.sectionDesc}>{SECTION_TITLES[activeSection].desc}</p>
            </div>
            <button className={styles.closeBtn} onClick={() => setActiveSection(null)} aria-label="Close section">✕</button>
          </div>

          {activeSection === 'users'    && <UsersSection />}
          {activeSection === 'products' && <ProductsSection />}
          {activeSection === 'auditlog' && <AuditLogSection />}
        </div>
      )}
    </div>
  );
}
